import { Card, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { DescriptionList } from '../../../../../components';
import { useCancelInfo } from '../listContent/cancelInfo';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';

export const CancelCard = ({ supervision, t }) => {
  const { cancelInfo, interruptInfo } = useCancelInfo({ supervision });
  return (
    <Card
      title={
        <CardTitle icon="close">{t('supervisions.show.cancel_info')}</CardTitle>
      }
    >
      <Row>
        <Col span={24}>
          {supervision.status === 'CANCEL' ? (
            <DescriptionList data={cancelInfo} translate />
          ) : (
            <DescriptionList data={interruptInfo} translate />
          )}
        </Col>
      </Row>
    </Card>
  );
};

CancelCard.propTypes = {
  supervision: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};
